import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExtractedLongFormInstructions,
  BackendMutationExtractLongFormInstructionsFromUrlArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractLongFormInstructionsFromUrl($projectId: ID, $sectionId: ID!, $url: String!) {
    extractLongFormInstructionsFromUrl(projectId: $projectId, sectionId: $sectionId, url: $url) {
      instructions
      status
      extractionErrors
    }
  }
`;

type Variables = Pick<
  BackendMutationExtractLongFormInstructionsFromUrlArgs,
  'projectId' | 'sectionId' | 'url'
>;
type Result = BackendExtractedLongFormInstructions;

export const extractLongFormInstructionsFromUrl = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
